import { useState } from 'react'
import {LuLayoutDashboard} from 'react-icons/lu'
 import { useTranslation } from 'react-i18next'
import CardHeadeWithActions from '../../components/ui/CardHeadeWithActions';
 import SalesReport from './SalesReport';
import OSListsPriceses from '../products/OSListsPriceses';
import ProductsCategories from '../products/ProductsCategories';
import ProductsBrands from '../products/ProductsBrands';
import ReportsNavbar from './ReportsNavbar';
import OsRequisitionReportCom from '../OsRequisitionReportPage';
import OSProductReport from './OSProductReport';
import Stocktakings_report from './Osstocktakings_report';

const ReportsHome = () => {
    const [t,i18n ] = useTranslation('global')
    const isRTL = i18n.dir() === 'rtl';
  
    const [tabActive,setTabActiive] = useState('SalesReport');

    return (
        <div className='p-3 overflow-hidden h-full'>
            <CardHeadeWithActions title={   <div className='flex items-center gap-2'>
      <LuLayoutDashboard size={18} /> {t('reports.Report_Settings')}
    </div>
}>
            </CardHeadeWithActions>
            
            <ReportsNavbar tabActive={tabActive} setTabActiive={setTabActiive}   />

            <div id='tab' className='bg-white rounded-b-lg border border-t-0 border-gray-200'>
                <div id='SalesReport'  
                    className={`flex flex-col gap-2 ${tabActive === 'SalesReport' ? 'block' : 'hidden'} `}>
                    <SalesReport/>
                </div>
                <div id='requisition_report'  
                    className={`flex flex-col gap-2 ${tabActive === 'requisition_report' ? 'block' : 'hidden'} `}>
                    <OsRequisitionReportCom/>
                </div>
                <div id='Product_Report'  
                    className={`flex flex-col gap-2 ${tabActive === 'Product_Report' ? 'block' : 'hidden'} `}>
                        <OSProductReport/>
                </div>
                <div id='stocktakings_report'  
                    className={`flex flex-col gap-2 ${tabActive === 'stocktakings_report' ? 'block' : 'hidden'} `}>
                        <Stocktakings_report/>
                </div> 
                <div id='Tags'  
                    className={`flex flex-col gap-2 ${tabActive === 'Tags' ? 'block' : 'hidden'} `}>
                        {/* <ProductsTags/> */}
                </div>
            </div>
        </div>
    );
}

export default ReportsHome